import usePeriods from "backend/hooks/model/usePeriods";
import { ICardElementWithChildren } from "backend/model/model";
import getValues from "backend/values";
import {
  Tbl,
  TblBody,
  TblBodyCell,
  TblBodyRow,
  TblHead,
  TblHeadCell,
  TblHeadRow,
} from "design/components/tables/ValueTable";
import Todo from "design/components/misc/Todo";
import React from "react";
import { useQuery } from "react-query";
import usePeriodLevels from "backend/hooks/model/usePeriodLevels";

const ValueHistory = (props: { element: ICardElementWithChildren }) => {
  const { data: periods } = usePeriods(props.element.periodlevel);
  const { data: periodLevels } = usePeriodLevels();
  const { data: values } = useQuery(
    `valuehistory-${props.element.id}-${JSON.stringify(periods)}`,
    () => {
      return periods
        ? getValues(props.element.id, periods, false, periodLevels!)
        : [];
    },
    {
      enabled: !!periodLevels,
    }
  );

  const usedRows = React.useMemo(() => {
    return values?.filter((v) => typeof v.TAR !== "undefined") || [];
  }, [periods, values]);
  return (
    <div>
      {values && values.length > 0 ? (
        <Tbl>
          <TblHead>
            <TblHeadRow>
              <TblHeadCell>Value Name</TblHeadCell>
              {usedRows.map((value) => (
                <TblHeadCell key={value.period?.name}>
                  {value.period?.name}
                </TblHeadCell>
              ))}
            </TblHeadRow>
          </TblHead>

          <TblBody>
            <TblBodyRow>
              <TblBodyCell>Actual</TblBodyCell>
              {usedRows.map((value) => (
                <TblBodyCell key={value.period?.name}>
                  {value.ACT_prettyvalue}
                </TblBodyCell>
              ))}
            </TblBodyRow>
            <TblBodyRow>
              <TblBodyCell>Target</TblBodyCell>
              {usedRows.map((value) => (
                <TblBodyCell key={value.period?.name}>
                  {value.TAR_prettyvalue}
                </TblBodyCell>
              ))}
            </TblBodyRow>

            <TblBodyRow>
              <TblBodyCell component="th" scope="row">
                Performance
              </TblBodyCell>
              {usedRows.map((value) => (
                <TblBodyCell
                  key={value.period?.name}
                  style={{
                    //                     boxShadow: `inset 0 12px 0px -6px #${value.rangecolor}`,
                    color: `#${value.rangecolor_KPI}`,
                    fontWeight: 500,
                    background: `linear-gradient(#${value.rangecolor_KPI}11, #${value.rangecolor_KPI}11)`,
                  }}
                >
                  {value.PERF_prettyvalue}
                </TblBodyCell>
              ))}
            </TblBodyRow>
            <TblBodyRow>
              <TblBodyCell>Actual (YTD)</TblBodyCell>
              {usedRows.map((value) => (
                <TblBodyCell key={value.period?.name}>
                  {value.ACT_YTD_prettyvalue}
                </TblBodyCell>
              ))}
            </TblBodyRow>
            <TblBodyRow>
              <TblBodyCell>Target (YTD)</TblBodyCell>
              {usedRows.map((value) => (
                <TblBodyCell key={value.period?.name}>
                  {value.TAR_YTD_prettyvalue}
                </TblBodyCell>
              ))}
            </TblBodyRow>

            <TblBodyRow>
              <TblBodyCell component="th" scope="row">
                Performance (YTD)
              </TblBodyCell>
              {usedRows.map((value) => (
                <TblBodyCell
                  key={value.period?.name}
                  style={{
                    //                     boxShadow: `inset 0 12px 0px -6px #${value.rangecolor}`,
                    color: `#${value.rangecolor}`,
                    fontWeight: 500,
                    background: `linear-gradient(#${value.rangecolor_PERF_YTD_OPEN}11, #${value.rangecolor_PERF_YTD_OPEN}11)`,
                  }}
                >
                  {value.PERF_YTD_prettyvalue || "-"}
                </TblBodyCell>
              ))}
            </TblBodyRow>
          </TblBody>
        </Tbl>
      ) : null}
    </div>
  );
};

export default ValueHistory;
